<script>
import _ from "lodash";

export default {
  name: "TheUnitSectionCardArch",

  props: {
    achievement: Object,
  },

  computed: {
    scoreUnitCard(){
      if (_.isNull(this.achievement.unit) && _.isNull(this.achievement.subunit)) return null
      if (_.isNull(this.achievement.subunit)) return this.achievement.unit.score
      else return this.achievement.subunit.score
    },

    nameUnitCard() {
      if (_.isNull(this.achievement.unit) && _.isNull(this.achievement.subunit)) return null
      if (_.isNull(this.achievement.subunit)) return this.achievement.unit.name;
      else return `${this.achievement.unit.name}/${this.achievement.subunit.name}`
    },
  }
}
</script>

<template>

  <v-card-text>
    <v-row>
      <v-col cols="4">
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-title v-show="scoreUnitCard !== null">{{scoreUnitCard}}</v-list-item-title>
            <v-list-item-icon v-show="scoreUnitCard === null"><v-icon small>fa-times-circle</v-icon></v-list-item-icon>
            <v-list-item-subtitle>Баллы</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="8">
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-title v-show="nameUnitCard !== null">{{nameUnitCard}}</v-list-item-title>
            <v-list-item-icon v-show="nameUnitCard === null"><v-icon small>fa-times-circle</v-icon></v-list-item-icon>
            <v-list-item-subtitle>Ед. измерения</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-card-text>

</template>

<style scoped>

</style>